<template>
<div>
    <div class="text-center vert-center" v-if="isLoading">
        <loader width="3rem"></loader>
    </div>
    <div v-else-if="!horizontal">
        <div class="form-group">
            <label class="form-label">Dagtarief <small>(07:00 - 18:00)</small></label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <div class="input-group-text">€</div>
                </div>
                <input min="15" type="number" :class="['form-control', ($v.dayRate.$dirty) ? ($v.dayRate.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="15" v-model="dayRate" @change="saveRate('dayRate', dayRate)" />
                <span class="invalid-feedback">
                    Het minimum tarief is € 12,50. Hiermee voldoen we minimaal aan hetgeen in de CAO staat.
                </span>
                <span class="valid-feedback">
                    U ontvangt € <span>{{(dayRate * 0.9).toFixed(2)}}</span> per uur (excl. BTW indien van toepassing).
                </span>
            </div>
        </div>
        <div class="form-group">    
            <label class="form-label">Avondtarief <small>(18:00 - 24:00)</small></label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <div class="input-group-text">€</div>
                </div>
                <input :min="minEveningRate" type="number" :class="['form-control', ($v.eveningRate.$dirty) ? ($v.eveningRate.$error) ?'is-invalid' : 'is-valid' : '']" :placeholder="minEveningRate" v-model="eveningRate" @change="saveRate('eveningRate', eveningRate)" />
                <span class="invalid-feedback">
                    Dient minimaal 110% van het standaard uurtarief te zijn.
                </span>
                <span class="valid-feedback">
                    U ontvangt € <span>{{(eveningRate * 0.9).toFixed(2)}}</span> per uur (excl. BTW indien van toepassing).
                </span>
            </div>
        </div>
        <div class="form-group">
            <label class="form-label">Nachttarief <small>(24:00 - 07:00)</small></label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <div class="input-group-text">€</div>
                </div>
                <input :min="minNightRate" type="number" :class="['form-control', ($v.nightRate.$dirty) ? ($v.nightRate.$error) ?'is-invalid' : 'is-valid' : '']" :placeholder="minNightRate" v-model="nightRate" @change="saveRate('nightRate', nightRate)" />
                <span class="invalid-feedback">
                    Dient minimaal 120% van het standaard tarief te zijn.
                </span>
                <span class="valid-feedback">
                    U ontvangt € <span>{{(nightRate * 0.9).toFixed(2)}}</span> per uur (excl. BTW indien van toepassing).
                </span>
            </div>
        </div>
        <div class="form-group">
            <label class="form-label">Hond Toeslag</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <div class="input-group-text">€</div>
                </div>
                <input min="0" type="number" :class="['form-control', ($v.dogRate.$dirty) ? ($v.dogRate.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="0" v-model="dogRate" @change="saveRate('dogRate', dogRate)" />
            
                <span class="invalid-feedback">
                    Deze toeslag wordt per uur toegevoegd aan uw standaard tarief.
                </span>
                <span class="valid-feedback">
                    U ontvangt € <span>{{(dogRate * 0.9).toFixed(2)}}</span> per uur toeslag (excl. BTW indien van toepassing).
                </span>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="row">
            <label class="form-label col-6">Dagtarief <br><small>(07:00 - 18:00)</small></label>
            <div class="col-6">
                <input min="15" type="number" :class="['form-control', ($v.dayRate.$dirty) ? ($v.dayRate.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="15" v-model="dayRate" @change="saveRate('dayRate', dayRate)" />
                <span class="invalid-feedback">
                    Het minimum tarief is € 12,50. Hiermee voldoen we minimaal aan hetgeen in de CAO staat.
                </span>
                <span class="valid-feedback">
                    U ontvangt € <span>{{(dayRate * 0.9).toFixed(2)}}</span> per uur (excl. BTW indien van toepassing).
                </span>
            </div>
        </div>
        <div class="row">    
            <label class="form-label col-6">Avondtarief <br><small>(18:00 - 24:00)</small></label>
            <div class="col-6">
                <input :min="minEveningRate" type="number" :class="['form-control', ($v.eveningRate.$dirty) ? ($v.eveningRate.$error) ?'is-invalid' : 'is-valid' : '']" :placeholder="minEveningRate" v-model="eveningRate" @change="saveRate('eveningRate', eveningRate)" />
                <span class="invalid-feedback">
                    Dient minimaal 110% van het standaard uurtarief te zijn.
                </span>
                <span class="valid-feedback">
                    U ontvangt € <span>{{(eveningRate * 0.9).toFixed(2)}}</span> per uur (excl. BTW indien van toepassing).
                </span>
            </div>
        </div>
        <div class="row">
            <label class="form-label col-6">Nachttarief <br><small>(24:00 - 07:00)</small></label>
            <div class="col-6">
                <input :min="minNightRate" type="number" :class="['form-control', ($v.nightRate.$dirty) ? ($v.nightRate.$error) ?'is-invalid' : 'is-valid' : '']" :placeholder="minNightRate" v-model="nightRate" @change="saveRate('nightRate', nightRate)" />
                <span class="invalid-feedback">
                    Dient minimaal 120% van het standaard tarief te zijn.
                </span>
                <span class="valid-feedback">
                    U ontvangt € <span>{{(nightRate * 0.9).toFixed(2)}}</span> per uur (excl. BTW indien van toepassing).
                </span>
            </div>
        </div>
        <div class="row">
            <label class="form-label col-6">Hond Toeslag</label>
            <div class="col-6">
                <input min="0" type="number" :class="['form-control', ($v.dogRate.$dirty) ? ($v.dogRate.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="0" v-model="dogRate" @change="saveRate('dogRate', dogRate)" />
            
                <span class="invalid-feedback">
                    Deze toeslag wordt per uur toegevoegd aan uw standaard tarief.
                </span>
                <span class="valid-feedback">
                    U ontvangt € <span>{{(dogRate * 0.9).toFixed(2)}}</span> per uur toeslag (excl. BTW indien van toepassing).
                </span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, numeric, minValue } from 'vuelidate/lib/validators';
import Loader from '@/components/Loader';
export default {
    name: 'rates',
    props: 
    {
        demo: {
            required: false,
            type: Boolean,
            default: false
        },
        date: {
            required: true,
            type: Object
        },
        horizontal: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    mixins: [validationMixin],
    components: {
        Loader
    },
    data() {
        return {
            isLoading: true,
            dayRate: 0,
            eveningRate: 0,
            nightRate: 0,
            dogRate: 0
        }
    },
    validations: {
        dayRate: {
            required,
            minValue: minValue(12.5),
            //numeric
        },
        eveningRate: {
            required,
            minValue: minValue(12.5),
            //numeric
        },
        nightRate: {
            required,
            minValue: minValue(12.5),
            //numeric
        },
        dogRate: {
            minValue: minValue(0),
            //numeric
        }
    },
    mounted() {
        this.getRates(this.date.date);
    },
    methods: {
        getRates(date)
        {
            if(date == null)
                return;

            this.isLoading = true;
            if(this.demo) 
            {  
                return new Promise((resolve, reject) => {
                    this.dayRate = 12.50.toFixed(2);
                    this.eveningRate = 12.50.toFixed(2);
                    this.nightRate = 12.50.toFixed(2);
                    this.dogRate = 2.00.toFixed(2);
                    this.isLoading = false;
                    this.availability = {};
                });
            } else {
                return this.$http.get('api/Rates?date=' + date.toDateString()).then((res) => {
                    this.dayRate = res.data.dayRate.toFixed(2);
                    this.eveningRate = res.data.eveningRate.toFixed(2);
                    this.nightRate = res.data.nightRate.toFixed(2);
                    this.dogRate = res.data.dogRate.toFixed(2);
                    this.isLoading = false;
                });
            }
        },
        saveRate(property, value)
        {
            this.$v[property].$touch();
            if(!this.$v[property].$invalid)
            {
                this.$http.post('api/Rates/' + property + '?date=' + this.date.date.toDateString(), value).then((res) => {
                    this[property] = res.data;
                    this.$emit('update', { property: property, value: value})
                });
            }
        }
    },
    computed: {
        minEveningRate() {
            return this.dayRate * 1.1
        },
        minNightRate() {
            return this.dayRate * 1.2
        },
        minWeekendRate() {
            return this.dayRate * 1.35
        },
    },
    watch: {
        date(val) {
            this.getRates(val.date);
        },
        dayRate() {
            /*
            if(this.eveningRate < this.dayRate * 1.1)
            {
                this.eveningRate = Math.ceil((this.dayRate * 1.1) * 100) / 100;
                this.saveRate("eveningRate", this.eveningRate);
            }
            if(this.nightRate < this.dayRate * 1.2)
            {
                this.nightRate = Math.ceil((this.dayRate * 1.2) * 100) / 100;
                this.saveRate("nightRate", this.nightRate);
            }
            */
        }
    }
}
</script>